import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
var toggleThemeNative = {
  width: 64,
  height: 32,
  labelMargin: 16,
  color: 'primary',
  slider: {
    width: 28,
    padding: 2,
    colors: {
      "default": colors.snowWhite,
      disabled: colors.cloudGrey
    }
  },
  background: {
    disabled: colors.fogGrey,
    inactive: colors.fogGrey
  },
  icon: {
    size: 18,
    colors: {
      disabled: colors.fogGrey
    }
  }
};

var toggleDarkThemeNative = _extends({}, toggleThemeNative, {
  slider: _extends({}, toggleThemeNative.slider, {
    colors: {
      "default": colors.cloudGrey,
      disabled: colors.octoberGrey
    }
  }),
  background: {
    disabled: colors.mineShaftGrey,
    inactive: colors.octoberGrey
  },
  icon: _extends({}, toggleThemeNative.icon, {
    colors: {
      disabled: colors.mineShaftGrey
    }
  })
});

var toggleThemeWeb = {
  color: 'primary',
  textColor: 'text',
  border: colors.fogGrey,
  disabled: colors.fogGrey,
  slider: {
    colors: {
      "default": 'background',
      disabled: colors.cloudGrey
    }
  },
  icon: {
    colors: {
      disabled: colors.fogGrey
    }
  }
};

var toggleDarkThemeWeb = _extends({}, toggleThemeWeb, {
  border: colors.octoberGrey,
  disabled: colors.emperorGrey,
  slider: {
    colors: {
      "default": 'background',
      disabled: colors.silverGrey
    }
  },
  icon: {
    colors: {
      disabled: colors.mineShaftGrey
    }
  }
});

export { toggleDarkThemeNative, toggleDarkThemeWeb, toggleThemeNative, toggleThemeWeb };